export class TempApproveRejectStpUserDto {
  stpMainId: number;
  isTempRejected: boolean;
  tempRejectReason: string;
  isPaymentIssue: boolean;
}
